import { useQuery } from '@tanstack/react-query';

import { getUserProfileVitrine } from '../apis/profile/activities';

type Args = {
  userId: string;
  enabled?: boolean;
};

export const useUserSummary = (args: Args) => {
  const { userId, enabled } = args;
  const userSummaryQuery = useQuery(
    ['user-vitrine', userId, 'activities'],
    async () => {
      const res = await getUserProfileVitrine(userId as string);
      return res.data;
    },
    {
      enabled,
      cacheTime: 30,
    },
  );

  return userSummaryQuery;
};
